<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("cmsPages") }}</div>
        <div class="section-subTitle my-2">
          {{ $tc("listofall") }} {{ $t("cmsPages") }}
        </div>
      </div>
      <div>
        <FilterByStatusDropdown
          :onSelect="
            (filterIsActive) => {
              getSeoList(filterIsActive);
            }
          "
        />
      </div>
    </div>
    <!-- LIST VIEW DESIGNATION -->
    <div class="desg-list-container">
      <div class="desg-list-header justify-content-start">
        <div class="pr-3">{{ $tc("status", 2) }}</div>

        <div>{{ $t("pages") }}</div>
      </div>
      <ul class="desg-list">
        <li
          v-for="(seo, seoKey) in seo_list"
          :key="seoKey"
          class="light_grey_back justify-content-start"
        >
          <!-- <div class="d-flex align-items-center">
            <StatusDot
              :status="
                seo.page_is_active === 'Y'
                  ? 'active'
                  : seo.page_is_active === 'N' && 'inactive'
              "
            />

            <b-dropdown
              right
              variant="edit"
              class="ml-2"
              v-if="$can('update', 'CMS Pages')"
            >
              <b-dropdown-item
                :to="{ name: 'Edit CMS Page', params: { seo_id: seo.seo_id } }"
              >
                <span class="edit-pen mr-1"></span>
                {{ $t("edit") }}
              </b-dropdown-item>
            </b-dropdown>
          </div> -->
          <div class="d-flex align-items-center">
            <StatusDot
              :status="
                seo.page_is_active === 'Y'
                  ? 'active'
                  : seo.page_is_active === 'N' && 'inactive'
              "
            />
            <router-link
              v-if="$can('update', 'CMS Pages')"
              :to="{ name: 'Edit CMS Page', params: { seo_id: seo.seo_id } }"
              class="ml-2"
              v-b-tooltip="'Edit'" tabindex="0"
            >
              <i class="edit-pen icon blue-icon"></i>
            </router-link>
          </div>

          <div class="pl-4">{{ seo.page_name }}</div>
        </li>
      </ul>
    </div>
    <br />
  </div>
</template>
<script>
import MarketingService from "@/services/MarketingService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
  },
  data() {
    return {
      seo_list: [],
    };
  },
  mounted() {
    this.getSeoList();
  },
  methods: {
    getSeoList: function (filterIsActive = "Y") {
      const payload = {
        filter_is_active: filterIsActive,
      };
      MarketingService.GetPageList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.seo_list = data.Records;
          } else {
            this.seo_list = [];
            this.$toasted.show(this.$t("No Records Found"));
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/PageComponents/listPage.vue